// import { createContext, useContext, useEffect, useState } from "react";
// import { io } from "socket.io-client";

// const SocketContext = createContext(null);

// export const SocketProvider = ({ children }) => {
//   const [socket, setSocket] = useState(null);

//   useEffect(() => {
//     const token = sessionStorage.getItem("accessToken");

//     const newSocket = io(process.env.REACT_APP_SOCKET_URL, {
//       transports: ["websocket", "polling"],
//       reconnection: true,
//       reconnectionAttempts: 10,
//       reconnectionDelay: 1000,
//       auth: { token },
//     });

//     newSocket.on("connect", () => {
//       console.log("SOCKET CONNECTED:", newSocket.id);

//       // 🔥 IMPORTANT: JOIN ROOM
//       const user = JSON.parse(sessionStorage.getItem("user"));

//       if (user?.id) {
//         newSocket.emit("join_user", user.id);
//         console.log("JOINED USER ROOM:", user.id);
//       }
//     });

//     newSocket.on("disconnect", (reason) => {
//       console.log("SOCKET DISCONNECTED:", reason);
//     });

//     newSocket.on("connect_error", (err) => {
//       console.log("SOCKET ERROR:", err.message);
//     });

//     setSocket(newSocket);

//     return () => {
//       newSocket.disconnect();
//     };
//   }, []);

//   return (
//     <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
//   );
// };

// export const useSocket = () => useContext(SocketContext);

import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");

    const socketUrl = process.env.REACT_APP_SOCKET_URL?.replace(/\/$/, "");

    if (!socketUrl) {
      console.error("SOCKET URL IS MISSING");
      return;
    }

    const newSocket = io(socketUrl, {
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      auth: {
        token,
      },
    });

    newSocket.on("connect", () => {
      console.log("✅ SOCKET CONNECTED:", newSocket.id);
    });

    newSocket.on("connect_error", (err) => {
      console.error("❌ SOCKET ERROR:", err.message);
    });

    newSocket.on("disconnect", (reason) => {
      console.log("⚠️ SOCKET DISCONNECTED:", reason);
    });

    setSocket(newSocket);

    return () => {
      newSocket.removeAllListeners();
      newSocket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
